module.exports = __webpack_public_path__ + "static/media/ftdna_mydna_transfer_ani.8d6c26ae.gif";